module.exports = __webpack_public_path__ + "images/emoji/loudspeaker.3ffbf64b9172f7de8e46.png";